import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GET_JOBS_BY_STATUS_DATE_ACTION, getJobsByStatusOrDate } from '../../../../actions';
import { createLoadingSelector } from '../../../../api/selectors';

const loadingSelectorList = createLoadingSelector([GET_JOBS_BY_STATUS_DATE_ACTION]);

export const useJobList = ({ status }) => {
  const dispatch = useDispatch();
  const sentinelRef = useRef(null);
  const jobList = useSelector((state) => state.job.jobList);
  const jobListPagination = useSelector((state) => state.job.jobListPagination);
  const isLoadingList = useSelector((state) => loadingSelectorList(state));

  useEffect(() => {
    dispatch(getJobsByStatusOrDate({ status }));
  }, [status, dispatch]);

  // Page-driven pagination: load the next page when the bottom sentinel scrolls
  // into view. The page itself scrolls (no fixed-height inner container).
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting && !jobListPagination?.isFinal && !isLoadingList) {
          dispatch(getJobsByStatusOrDate({ status, enablePagination: true }));
        }
      },
      { rootMargin: '300px' },
    );
    observer.observe(sentinel);

    return () => observer.disconnect();
  }, [status, dispatch, jobListPagination?.isFinal, isLoadingList]);

  return {
    sentinelRef,
    jobList,
    isLoadingList,
  };
};
